import React, { useEffect, useState } from "react";

function LocationApp() {
  const [country, setCountry] = useState("");
  const [error, setError] = useState("");

  // useEffect(() => {
  //   const fetchCountry = async () => {
  //     try {
  //       const response = await fetch("http://ip-api.com/json/");
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch location data");
  //       }
  //       const data = await response.json();
  //       console.log("API Response:", data); // Debugging
  //       setCountry(data.country);
  //     } catch (error) {
  //       setError("Error fetching country information");
  //       console.error("Error fetching country:", error);
  //     }
  //   };

  //   fetchCountry();
  // }, []);


 useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await fetch("https://free.freeipapi.com/api/json");
        if (!response.ok) {
          throw new Error("Failed to fetch location data");
        }
        const data = await response.json();
        console.log("API Response:", data); // Debugging
        setCountry(data.countryName);
      } catch (error) {
        setError("Error fetching country information");
        console.error("Error fetching country:", error);
      }
    };

    fetchCountry();
  }, []);

  return (
  //   <div>
  //   {country == "" ? (
  //     <Link
  //       className=" lg:mr-5 xl:mr-12 hover:underline"
  //       onClick={fetchCountry}
  //     >
  //       Select Country
  //     </Link>
  //   ) : (
  //     <h1 className=" lg:mr-5 xl:mr-12">{country}</h1>
  //   )}
  // </div>
    <div>
      {error ? (
        <p className="text-red-500">{error}</p>
      ) : !country ? (
        <p>Loading country...</p>
      ) : (
        <h1 className="lg:mr-5 xl:mr-12">{country}</h1>
      )}
    </div>
  );
}

export default LocationApp;
